export default function log({ next, to }) {
    // console.log('middleware: log');
    // console.log(to);
    // console.log(to.name);

    return next();
}
